import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, NavItem, Navbar,  InputGroup, FormControl, Button } from "react-bootstrap";
import Routes                       from "./Routes";
import RouteNavItem                 from "./components/RouteNavItem";
//import { authUser, signOutUser } from "./libs/awsLib";
import { Auth }                     from "aws-amplify";
import styled, {ThemeProvider}      from 'styled-components';
import theme                        from 'styled-theming';
import ModalHelpYouTube             from "./components/modal/ModalHelpYouTube";
import { invokeGetUnreadMessages }  from "./utils/AwsInvoke";
import { library }                  from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import { fas }                      from '@fortawesome/free-solid-svg-icons'
import { Colors }                   from "./utils/Colors";
import uniqueId                     from 'lodash/uniqueId';
import "./css/App.css";
library.add(fas)

const StyledNavbar = styled(Navbar)`
    background-color: ${props => props.theme.primary};
	border: 0px solid #ccc;
`;


const StyledImageLogo = {
    float:          "left",
    position:       "relative",
    paddingTop:     "13px",
    left:           "-10px",
    paddingBottom:  "5px",
    maxHeight:      "90px",
    maxWidth:       "230px"
}

class App extends Component {
    constructor(props) {
      super(props);

      var globalAdminUserId = localStorage.getItem('globalAdminUserId'); //

      this.state = {
          isAuthenticated: false,
          isAuthenticating: true,
          unReadMessages: 0,
          searchTerm: "",
          unReadMessageIdsArray: [],
          globalCompanyId: this.props.companyId,
          globalAdminUserId: globalAdminUserId,
          showProcessingHeader: "none",
          showCompletedProcessingHeader: "none",
          processingMessage: "",
          showModalAlert:      false, // true | false
      };
    }

    getCurrentMonthDayTime() {
        var today = new Date();
        var date = today.getYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+"T"+today.getHours()+":" + today.getMinutes() + ":" + today.getSeconds();

        return date;
    }

    set4HoursToCurrentMonthDayTime() {
        var today = new Date();
        var date = today.getYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+"T"+(today.getHours()+3)+":" + today.getMinutes() + ":" + (today.getSeconds() + 0);

        return date;
    }

    compareDate(newDate, prevDate) {
        // Sample
        //var newDate = Date.parse("2012-11-01T00:00:00");
        //var prevDate = Date.parse("2012-11-01T00:00:01");
        var redirect = false;
        if (newDate > prevDate) redirect = true;

        return redirect;
    }

    async componentDidMount() {
        try {
            var globalAdminUserId = this.state.globalAdminUserId;
            // console.log("App.js Global Admin User Id: " + globalAdminUserId);
            // If app loads and the User Id is not tracked, have user login again //
            if(globalAdminUserId === "null" || globalAdminUserId === null)
                this.handleLogout(null);
            else
                if (await Auth.currentSession() /*await authUser()*/) {
                    //console.log("0. CHECK IN APP.js Current session valid!");
                    this.userHasAuthenticated(true);

                    // 9.26. hold on to this; it works fine but...
                    // the search fields get cleared during the timer increment;
                    // i think it's because either there's a new state change
                    // or the aws invoke feature or both reasons
                    // INITIATE RETRIEVAL OF NEW MESSAGES //
                    // this.wait30SecsThenCheckMessages();
                }
        }
        catch(e) {
            //alert("App.js error: " + e); //"no current user" message
        }

        this.setState({ isAuthenticating: false });
    }

    wait30SecsThenCheckMessages(action) {
        /**  REASON for this Function  **
        The reason this function is instantiated is to give the server time to authenticate the user and process
        the Auth request. If this "wait" timer is not set and the trainer loads the page immediately/right away,
        the error below will display one out of every 3 -5 times.

        /* awsLib.js:149 Uncaught (in promise) TypeError: __WEBPACK_IMPORTED_MODULE_4__sigV4Client__.a.newClient(...).signRequest is not a function */

        var timer_secs = 10; // seconds to wait until the function begins to check the database for new messages
        var timer;
        var that  = this;

        startTimer();

        function startTimer () {
            timer = setInterval(function(){
                timer_secs--;
                console.log("Init timer: " + timer_secs);
                if(timer_secs <= 0) {
                    clearInterval(timer);
                    that.checkForUnreadMessages();
                }
            }, 1000);
        }
    }


    userHasAuthenticated = authenticated => {

        this.setState({
            isAuthenticated: authenticated
        }, function(){
            //console.log("2. HIT authenticate");
        });

        var tmp_url_str = this.props.location.pathname;
        var sub_str = tmp_url_str.match("/(.*)/");

        // if user logs in freshly, and not from another page, redirect user to index
        if(sub_str === null)
            this.props.history.push("/index");

        var now = this.getCurrentMonthDayTime();
        var dateLastModified  = localStorage.getItem('dateLastModified');
        //console.log("current date : " + now);
        //console.log("date Last Modified: " + dateLastModified);

        var redirect = this.compareDate(now, dateLastModified);

        //// Set App's Date & Time, if app has not been used for more than 3 hours, redirect user to the Dashboard screen
        localStorage.setItem('dateLastModified', this.set4HoursToCurrentMonthDayTime());

        //console.log("redirect: " + redirect);
        // If it's been over 3 hours since the admin logged in, go to
        // working incorrectly...
        // if(redirect) this.props.history.push("/index");
    }

    handleLogout = event => {
        //console.log("1. App.js handleLogout");
        //old: signOutUser();
        Auth.signOut();

        localStorage.setItem('globalAdminUserId', null); // reset global user id
        localStorage.setItem('trainer_company_id', null); // reset trainer's company id

        sessionStorage.setItem('company_id', null); // reset trainer's company id

        this.setState({
            isAuthenticated: false,
            globalCompanyId: this.props.companyId // reset global company id
        }, function(){
            //// don't use this function - userHasAuthenticated(false) - since it "pushes" to /index
            this.props.history.push("/login");
        });

    }

    resetGlobalIds = () => {
        //console.log("App.js reset ids");

        this.setState({
            isAuthenticated: false,
            globalCompanyId: this.props.companyId // reset global company id
        });
    }

    ////  *** Used for Trainers on free trial ONLY ***    ////
    ////  Reset company id from white label props         ////
    setNewGlobalCompanyId = company_id => {
        localStorage.setItem('trainer_company_id', company_id);
        sessionStorage.setItem('company_id', company_id);
        this.setState({
            globalCompanyId: company_id
        })
    }

    setGlobalAdminUserId = user_id => {
        localStorage.setItem('globalAdminUserId', user_id);
        this.setState({
            globalAdminUserId: user_id
        })
    }

    setGlobalTrainerOnTrialPeriod = free_trial => {
        localStorage.setItem('globalTrainerOnTrialPeriod', free_trial);
        this.setState({
            globalTrainerOnTrialPeriod: free_trial
        })
    }

    setGlobalAdminUserRoleId = role_id => {
        localStorage.setItem('globalAdminUserRoleId', role_id);
        this.setState({
            globalAdminUserRoleId: role_id
        })
    }

    setGlobalAdminUserEmail = user_email => {
        localStorage.setItem('globalAdminUserEmail', user_email);
        this.setState({
            globalAdminUserEmail: user_email
        })
    }

    setGlobalExerciseVideoOptions = () => {
        var exercise_video_options = localStorage.getItem('exercise_video_options');

        ////  Set Default Settings for 1st Time visitors to TS Admin; Exercie Library Settings = All Videos  ////
        if(exercise_video_options != "customvideos")
            localStorage.setItem("exercise_video_options", "allvideos");
    }

    resetUnreadMessageIcon = () => {
        this.setState({
            unReadMessages: 0 // when resetting, number will always be 0
        })
    }

    checkForUnreadMessages = async () => {

        this.setState({
            unReadMessages: false,
            unReadMessageIdsArray: [] // reset
        })
        console.log("**********  TRAINER SIDE TIMER  **********");
        var results = await invokeGetUnreadMessages();

        if(results.length > 0) {
            console.log("*****  THERE's a NEW MESSAGE!!!  *****  ");
            var msg_array = [];
            for(var key in results) {
                var message_id = results[key].message_id;

                msg_array.push(message_id);
            }
            this.setState({
                unReadMessages: true,
                unReadMessageIdsArray: msg_array,
                showNewMessage: "inline"
            })

            // Begin Once: check for new messages every 15 secs
            this.startCheckNewMessagesTimer("reset");
        } else {
            console.log("There's NO New Messages....");
            this.setState({
                unReadMessages: false,
                unReadMessageIdsArray: [] // reset
            })
            // Begin Once: check for new messages every 15 secs
            this.startCheckNewMessagesTimer("reset");
        }/* */
    }

    startCheckNewMessagesTimer(action) {
        console.log("----- BEGIN Timer -----");
        var timer_secs = 15; // seconds for refresh rate
        var timer;
        var that  = this;
        //clearInterval(timer);
        if(action === "reset") {
            //console.log("ACTION RESET only once");
            clearInterval(timer);
            startTimer();
        }

        function startTimer () {
            timer = setInterval(function(){
                timer_secs--;
                that.setState({
                    pageTimerSecs: timer_secs,
                    refreshPageTimer: false //reset timer
                })
                //console.log("this.timer: " + timer_secs);
                if(timer_secs <= 0) {
                    clearInterval(timer);
                    //that.getMessagesList("Retrieving Message ... ")
                    that.checkForUnreadMessages();
                }
            }, 1000);
        }
    }


    ////  BEGIN: SEARCH BOX  ////
    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchClients();
    }

    searchClients = () => {
        var search_term = this.state.searchTerm;
        search_term = this.searchInput.value;
        if(search_term.length === 0) search_term = "&";

        var term        = search_term.toLowerCase()
        this.props.history.push("/client/listAll/"+term)
    }

    clearSearchField = () => {
        this.setState({
            searchTerm: "", // reset search term if resetting member list
        })
    }

    changeProcessingHeader = (action, message) => {

        if(action === "processMessage") {
            var p_message = "1. " + message;
            this.setState({
                showProcessingHeader: "inline",
                processingMessage: p_message,
                greenHeaderYpos: 30
            })
        } else if(action === "hideProcessingMessage"){
            // Hide Message and header bar
            this.setState({
                showProcessingHeader: "none",
                processingMessage: "",
                completeProcessingMessage: "The program has finished processing.",
                showCompletedProcessingHeader: "inline",
                greenHeaderYpos: 0
            })

            ////  CLOSE THE GREEN HEADER BAR AFTER 3 SECONDS  ////
            var timer = setInterval(startTimer, 3000);
            var that = this;
            function startTimer() {
                console.log("clear green header timer. ");
                clearInterval(timer)
                that.setState({
                    showCompletedProcessingHeader: "none"
                });
            }
        }
    }

    showPageHelpVideo = () => {
        console.log("showPageHelpVideo!!!!!!!!!!");
        this.setState({
            modalAlertTitleText: "HELP: Dashboard Page",
            modalAlertBodyText:  "Sorry, as a trial member you're not allowed to add anymore clients.",
            showModalAlert:      true,
            alertObject:         "", // used to delete programs; not req'd
            alertAction:         ""
        })
    }

    ////  END: SEARCH BOX  ////

    render() {
        var tmp_url_str = this.props.location.pathname;
        var current_sub = tmp_url_str.split('.com/')[0];
        var show_search = "inline-block";

        if(current_sub === "/" || current_sub === "/login" || current_sub === "/signup" || current_sub === "/reset")
            show_search = "none"

        // used to test free trial trainer company ids (is it the same or not):
        // console.log("App render globalCompanyId: " + this.state.globalCompanyId);

        const childProps = {
              isAuthenticated: this.state.isAuthenticated,
              resetGlobalIds: this.resetGlobalIds,
              userHasAuthenticated: this.userHasAuthenticated,
              setNewGlobalCompanyId: this.setNewGlobalCompanyId,
              setGlobalAdminUserEmail: this.setGlobalAdminUserEmail,
              setGlobalAdminUserId: this.setGlobalAdminUserId,
              setGlobalTrainerOnTrialPeriod: this.setGlobalTrainerOnTrialPeriod,
              setGlobalAdminUserRoleId: this.setGlobalAdminUserRoleId,
              globalAdminUserId: this.state.globalAdminUserId,
              globalAdminUserEmail: this.state.globalAdminUserEmail,
              resetUnreadMessageIcon: this.resetUnreadMessageIcon,
              globalCompanyId: this.state.globalCompanyId,
              setGlobalExerciseVideoOptions: this.setGlobalExerciseVideoOptions,
              changeProcessingHeader: this.changeProcessingHeader
        };

        var renderHome = <div style={{position:"relative",top:"120px", left: "120px"}}></div>;
            
        if(!this.state.isAuthenticating)
            renderHome = <div className="App " style={{position:"relative", left: "30px", width:"90%"}}> {/*className="App container"*/}

                                <Link to="/index">
                                    <img src={this.props.logo} style={StyledImageLogo} alt={"logo"}/>
                                </Link>

                                <div style={{display: "inline-block", paddingTop:60}} />

                                <span className="universalSearchBox" style={{display: show_search}}>
                                    <InputGroup style={{borderRadius: "15px !important"}}>
                                      <FormControl key = {uniqueId()}
                                                   type="text"
                                                   className="border-0"
                                                   style={{borderRadius: "15px !important"}}
                                                   placeholder="Client Search"
                                                   defaultValue={this.state.searchTerm}
                                                   inputRef={ref => { this.searchInput = ref; }}
                                                   onKeyPress={this.handleKeyPress}
                                               />

                                        <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                              onClick={() => this.clearSearchField()}
                                        />
                                        <InputGroup.Button>
                                          <Button className="universalSearchButton"
                                                  onClick={() => this.searchClients()}>Search</Button>
                                        </InputGroup.Button>
                                    </InputGroup>
                                        { /*}<span style={{position: "relative", top: 5, left:160, color: Colors.default_blue}}
                                              onClick={() => this.showPageHelpVideo()}>
                                            Page Help
                                        </span>
                                        <span className="glyphicon glyphicon-question-sign"
                                              style={{ position: "relative", top: 10, left:170, color:"#999", fontSize: '1.5em', color: Colors.default_blue }}
                                              onClick={() => this.showPageHelpVideo()}
                                        />*/ }
                                </span>
                                { /*}<StyledNavbar fluid collapseOnSelect>
                                      <Navbar.Header>
                                            <Link to="/index">
                                                <img src={logo} style={StyledImageLogo} alt={logo}/>
                                            </Link>
                                        <Navbar.Brand>
                                          { /*}< Link to="/">TS Test App</Link> / }
                                        </Navbar.Brand>
                                        <Navbar.Toggle />
                                      </Navbar.Header>
                                    </StyledNavbar>*/ }

                                <Routes childProps           = {childProps}
                                        userHasAuthenticated = {this.userHasAuthenticated}
                                        resetGlobalIds       = {this.resetGlobalIds}
                                        unReadMessages       = {this.state.unReadMessages}
                                    />
                    </div>

        if(!this.state.isAuthenticating) {
            //this.props.history.push("/login");
        }
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
        return (
            <div style={{backgroundColor: "#fff"}}>
                <div className="processingHeader" style={{display: this.state.showProcessingHeader}}> {this.state.processingMessage} </div>
                <div className="completedProcessingHeader"
                     style={{display: this.state.showCompletedProcessingHeader, top: this.state.greenHeaderYpos}}
                >
                     {this.state.completeProcessingMessage}
                </div>
                {this.state.showModalAlert ?
                    <ModalHelpYouTube
                        onHide         = {closeModalAlert}
                        //alertFunction  = {this.alertFunction}     // custom function to call within modal
                        alertAction    = {this.state.alertAction} // flag used for above function
                        alertObject    = {this.state.alertObject} // vars used for above function
                        showModalAlert = {this.state.showModalAlert}
                        messageTitle   = {this.state.modalAlertTitleText}
                        messageBody    = {this.state.modalAlertBodyText}
                    />
                : null}
                { renderHome }

            </div>
        )
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js